<template>
  <div class="modal">
    <div class="modal-content loading">
      <img src="../assets/images/loading.svg"> {{ loadingText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading',
  props: {
    loadingText: {
      type: String,
      default: 'Carregando'
    }
  }
}
</script>
